export default __webpack_public_path__ + "img/add-game.568e6e2b.svg";